import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class TemplateForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      type: [ '', Validators.required ],
      name: [ '', Validators.required ],
      isDefault: [ '' ],
      language: [ '', Validators.required ],
      content: [ '', Validators.required ],
      subject: [ '', Validators.required ]
    });
  }
}
